import Response from '@/shared/types/response';
import chunkArray from '@/shared/utils/chunkArray';
import fetcher from '@/shared/utils/fetcher';
import getCookie from '@/shared/utils/getCookie';

type Props<T> = {
  body: T[];
  onUnauthorized?: () => void;
  onProgress?: (progress: number) => void;
};

const createMetadata = async <T>({
  body,
  onUnauthorized,
  onProgress,
}: Props<T>) => {
  const token = getCookie('auth_token');
  const chunksIds = chunkArray(body, 5);

  let finishedRequests = 0;
  const totalRequests = body.length;

  const results: Response<object | Record<string, string>>[] = [];

  for (const chunk of chunksIds) {
    const promises = chunk.map((item) => {
      return fetcher<Response<object>>({
        token,
        retries: 3,
        url: '/inventory/metadata/create/',
        method: 'POST',
        body: item,
        onUnauthorized,
      })
        .then((response) => {
          finishedRequests++;

          if (onProgress) {
            onProgress((finishedRequests / totalRequests) * 100);
          }

          return response;
        })
        .catch((error) => {
          console.error(
            'Error occurred in function "createMetadata" in file "src/shared/api/product/createMetadata.ts":',
            error,
          );

          return { ...error, data: item } as Response<Record<string, string>>;
        });
    });

    const chunkResults = await Promise.all(promises);
    results.push(...chunkResults);
  }

  return results;
};

export default createMetadata;
